import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['totalAmount', 'totalCount', 'cashAmount', 'cashCount',
                    'checkAmount', 'checkCount', 'submitButton']

  connect() {
    this.update()
  }

  update() {
    // Totals
    this.totalAmountTarget.innerHTML = this.convertToCurrency(this.totalAmount)
    this.totalCountTarget.innerHTML = `${this.selected.length} donations`
    // Checks
    this.checkAmountTarget.innerHTML = this.convertToCurrency(this.checkAmount)
    this.checkCountTarget.innerHTML = `${this.checks.length} checks`
    // Cash
    this.cashAmountTarget.innerHTML = this.convertToCurrency(this.cashAmount)
    this.cashCountTarget.innerHTML = `${this.cash.length} cash`
    this.enableSubmit()
  }

  toggleCheckbox(event) {
    const box = event.currentTarget.querySelector("input[type=checkbox]")
    box.checked ^= 1
    this.update()
  }

  // Private ----------------------->

  enableSubmit() {
    this.submitButtonTarget.disabled = this.totalAmount <= 0
  }
  
  convertToCurrency(value) {
    return '$' + value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
  }

  get selected(){
    return this.element.querySelectorAll('input[type=checkbox]:checked')
  }

  get checks() {
    return this.element.querySelectorAll('input[type=checkbox]:checked[data-donation-type="check"]')
  }

  get cash() {
    return this.element.querySelectorAll('input[type=checkbox]:checked[data-donation-type="cash"]')
  }

  get totalAmount() {
    return this.sumAmounts(this.selected)
  }

  get checkAmount() {
    return this.sumAmounts(this.checks)
  }

  get cashAmount() {
    return this.sumAmounts(this.cash)
  }

  get countChecks() {
    return this.checks.length
  }

  get countCash() {
    return this.cash.length
  }


  // private ------------------------>

  sumAmounts(elements) {
    let sum = 0
    elements.forEach(
      (target) => {
         sum += parseFloat(target.dataset.donationAmount)
      })
    return sum
  }
}